module.exports = __webpack_public_path__ + "img/play_store1.f3944232.png";